import type { FilterFieldDef } from './types'
import { GrowerSearchSelect } from '@/components/growers/grower-search-select'

interface GrowerFilterOptions {
    label: () => string
    placeholder?: () => string
}

/**
 * Bộ lọc theo hộ trồng — viết như một factory bình thường, `core` không biết
 * nó tồn tại. Đây là bài kiểm tra cho điểm mở rộng: nếu viết được cái này mà
 * không đụng core thì hợp đồng `FilterFieldDef` đủ dùng.
 *
 * Giá trị là id hộ trồng, rỗng nghĩa là "tất cả". Không validate được id theo
 * một danh sách cố định vì danh sách nằm ở server và phân trang — nên `parse`
 * chỉ chặn kiểu sai và chuỗi rỗng.
 *
 * KHÔNG tự sinh `chipLabel`: từ id không suy ra được tên hộ, mà hiện id thô lên
 * chip thì người dùng không đọc được. Màn nào cần chip thì truyền tên đã tra
 * qua `chipLabels` của `useListFilters` (xem `/tea-purchases`).
 */
export function growerFilter({
    label,
    placeholder,
}: GrowerFilterOptions): FilterFieldDef<string> {
    return {
        defaultValue: '',
        label,
        parse: (raw) => (typeof raw === 'string' && raw ? raw : undefined),
        // Từ id không suy ra được tên hộ; hiện id thô lên chip thì vô nghĩa.
        chipLabel: () => undefined,
        render: ({ id, value, onChange }) => (
            <GrowerSearchSelect
                id={id}
                value={value}
                onChange={(growerID) => onChange(growerID)}
                placeholder={placeholder?.()}
                allowClear
            />
        ),
    }
}
